
import { useAllJobsContext } from "@/pages/all-jobs";
import { JobsContainerWrapper } from "@/components/wrappers";

import { Job, PageBtnContainer } from ".";

const JobsContainer = () => {
  const { data } = useAllJobsContext();
  const { jobs, total, pages } = data;

  if (jobs.length === 0) {
    return (
      <JobsContainerWrapper>
        <h2>No jobs to display...</h2>
      </JobsContainerWrapper>
    );
  }

  return (
    <JobsContainerWrapper>
      <h5>
        {total} job{total > 1 && "s"} found
      </h5>
      <div className="jobs">
        {jobs.map(job => {
          return <Job key={job._id} {...job} />;
        })}
      </div>
      {pages > 1 && <PageBtnContainer />}
    </JobsContainerWrapper>
  );
};

export default JobsContainer;
